<template>
  <div v-if="items !== null">
    <div
      class="box-next-content"
      :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'"
    >
      <div class="nextContentTitle" v-if="metadata.title" :style="({color: $theme.primaryColor})" >
        <div class="nextContentTitleLeft">
        <IconPlayScreen />
        <div
          class="line-clamp-2 "
          :style="({color: $theme.primaryColor})"
        >
          <img class="icon-carousel"
            v-if="metadata.isPreview && metadata.state == 'Published'"
            src="@/assets/icons/check-circle-copy.svg"
          />
          <img class="icon-carousel"
            v-if="metadata.isPreview && metadata.state == 'Draft'"
            src="@/assets/icons/edit.svg"
          />
          <img class="icon-carousel"
            v-if="metadata.state == 'Unpublished'"
            src="@/assets/icons/lock.svg"
          />
          <img class="icon-carousel"
            v-if="metadata.state == 'Scheduled' && metadata.releasedDate"
            src="@/assets/icons/lock.svg"
          />
          <span
            style="font-size: 12px; font-style: italic"
            v-if="metadata.state == 'Scheduled' && metadata.releasedDate"
            >(liberado em
            {{ new Date(metadata.releasedDate) | formatDate }})</span
          >
           {{ metadata.title }}
        </div>
        <div
          class="see-all"
          @click="openLeftMenu()"
          v-show="showAll"
          :style="({color: $theme.primaryColor, borderColor: $theme.primaryColor})"
        >
          <i class="material-icons">menu</i>Ver todos
        </div>
      </div>
      <div class="nav-btn">
        <div :class="'swiper-button-prev--'+_uid" class="swiper-button-prev" :style="({borderColor: $theme.primaryColor, color:$theme.primaryColor })" slot="button-prev"></div>
        <div :class="'swiper-button-next--'+_uid" class="swiper-button-next" :style="({borderColor: $theme.primaryColor, color:$theme.primaryColor })" slot="button-next"></div>
    </div>
      </div>


      <div class="nextCarousel">
        <div
          class="box-next-content"
          :style="$theme.darkTheme ? '' : 'background-color: #f2f3f7'"
        >
          <div class="nextCarousel">
            <swiper
              :ref="'swiper-class-id-' + metadata.classId"
              :class="'swiper-class-id-' + metadata.classId"
              :options="swiperOption"
            >
              <template v-for="(item, itemIndex) in items">
              <swiper-slide
                :class="['item', 'swiper-class-id-item-' + metadata.classId]"
                :style="$theme.darkTheme ? '' : 'background: #fff'"
                :key="item.id"
              >
                <a href="javascript:;" @click.prevent="click(item)">
                  <img v-lazy="itemImage(item)" class="poster" />
                  <!-- <div class="item-time" v-if="item.broadcast">
                    {{ item | formatDuration }}
                  </div> -->
                  <ProgressBar
                    class="item-progress-bar"
                    v-if="!hideProgress"
                    :value="item.progress"
                    :color="$theme.primaryColor"
                  ></ProgressBar>
                  <!-- <div class="item-class">
                    {{ item.category }} {{ item.progress }}
                  </div> -->
                  <div class="item-info">


                  
                  <!-- categoria -->
                  <div
                    class="item-module line-clamp-1"
                    style="font-size: 10px; color: #FFFFFF99"
                    :style="$theme.darkTheme ? '' : 'color: #A0A0A0'"
                  >
                    {{ item.category }}
                  </div>
                  <!-- Nome da aula -->
                  <div
                    class="item-name line-clamp-2"
                    style="font-size: 12px; color: #FFFFFFE5; font-weight: 800"
                    :style="({color: $theme.primaryColor})"
                  >

                    <img
                      v-if="item.isPreview && item.state == 'Published'"
                      src="@/assets/icons/check-circle-copy.svg"
                    />
                    <img
                      v-if="item.isPreview && item.state == 'Draft'"
                      src="@/assets/icons/edit.svg"
                    />
                    <img
                      v-if="item.state == 'Unpublished'"
                      src="@/assets/icons/lock.svg"
                    />
                    <img
                      v-if="item.state == 'Scheduled'"
                      src="@/assets/icons/lock.svg"
                      v-tooltip.top="{ content: formatScheduleInfo(item) }"
                    />
                    {{ item.title }}
                  </div>
                </div>
                <!-- dados da aula -->
                <div class="item-footer">

                  <div class="flex-between flex-v-center">
 
                    <div class="item-module"
                    :style="$theme.darkTheme ? '' : 'color: #A0A0A0'"
                    >
                    {{ item.progress }}%
                   </div>
                   <div class="item-module flex-v-center"
                   :style="$theme.darkTheme ? '' : 'color: #333333'"
                   >
                   <span :style="({color: $theme.primaryColor})" >
                    {{item.progress ? 'Continuar' : 'Assistir'}}
                  </span>
                   <IconPlay />
                   
                 </div>
               </div>
                </div>


               
                </a>
              </swiper-slide>
              <!-- Story-6066: recomendação logo após o 1º card (uma por vez, em rodízio) -->
              <template v-if="itemIndex === 0">
                <swiper-slide
                  v-for="rec in recommendationList"
                  :key="'recommendation_' + rec.offerId"
                  class="item item-recommendation"
                  :style="$theme.darkTheme ? '' : 'background: #fff'"
                >
                  <RecommendationCard :product="rec" />
                </swiper-slide>
              </template>
              </template>
              <!-- Sem próximos conteúdos (última aula): só as recomendações -->
              <template v-if="!items.length">
                <swiper-slide
                  v-for="rec in recommendationList"
                  :key="'recommendation_' + rec.offerId"
                  class="item item-recommendation"
                  :style="$theme.darkTheme ? '' : 'background: #fff'"
                >
                  <RecommendationCard :product="rec" />
                </swiper-slide>
              </template>

              <!-- <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div> -->
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "@voxel/vue-awesome-swiper";
import { formatDate } from "@/filters/formatDate";
import ProgressBar from "@/components/UI/ProgressBar";
import { mapState } from "vuex";
import "@voxel/swiper/css/swiper.css";
import IconPlay from "@/components/UI/IconPlay";
import IconPlayScreen from "@/components/UI/IconPlayScreen";
import RecommendationCard from "@/components/ProductRecommendation/RecommendationCard.vue";

export default {
  name: "Carousel",
  props: ["showCategory", "items", "metadata", "hideProgress", "recommendations"],
  components: { Swiper, SwiperSlide, ProgressBar, IconPlay, IconPlayScreen, RecommendationCard },
  computed: {
    ...mapState({
      selectedEnroll: (state) => state.enroll.current,
    }),
    recommendationList() {
      return Array.isArray(this.recommendations) ? this.recommendations : [];
    },
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 15,
        // Re-mede quando o DOM/atributos do container mudam (ex.: menu lateral
        // abre/fecha) — sem isso o fim do carousel fica com a largura antiga
        // e o ultimo card nao aparece.
        observer: true,
        observeParents: true,
        //freeMode: true,
        // slidesOffsetAfter: 20,
        // slidesOffsetBefore: 50,
        // slidesPerGroup: 3,
        navigation: {
          nextEl: ".swiper-button-next--"+this._uid,
          prevEl: ".swiper-button-prev--"+this._uid,
        },
        // nextButton: ".swiper-button-next",
        // prevButton: ".swiper-button-prev",
        //touchEventsTarget: 'container'
      },
      showAll: false,
    };
  },
  mounted() {
    if (!this.items || !this.metadata.classId) return false;

    this.updateSizes();

    // O container pode mudar de largura depois do mount (layout/menus) e o swiper
    // nao re-mede sozinho: o fim do carousel fica calculado com a largura antiga
    // e o ultimo card nao aparece. Re-mede a cada resize do container (mesmo
    // padrao do Trustflix/DynamicSection).
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(
      this.$refs["swiper-class-id-" + this.metadata.classId].$el
    );
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    clearTimeout(this.resizeDebounce);
  },
  methods: {
    onResize() {
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(this.updateSizes, 200);
    },
    updateSizes() {
      const swiperRef = this.$refs["swiper-class-id-" + this.metadata.classId];
      if (!swiperRef) return;

      if (swiperRef.$swiper) swiperRef.$swiper.update();

      // mesma regra do mount original: "Ver todos" quando nao cabe tudo
      const slides = this.items.length + this.recommendationList.length;
      this.showAll = swiperRef.$el.clientWidth < slides * 260;
    },
    itemImage(item) {
      if (item.broadcast) {
        return item.image + "?h=146";
      }
      return item.image;
    },
    click(item) {
      const eventData = {
        ...item,
        ...this.metadata,
      };
      if (item.state == "Published") this.$emit("click", eventData);
    },
    openLeftMenu() {
      if (this.metadata) this.$emit("openLeftMenu", this.metadata.classId);
    },
    formatScheduleInfo(obj) {
      if (obj.state == "Scheduled" && obj.releasedDate)
        return "Liberado em " + formatDate(new Date(obj.releasedDate));
      return obj.title;
    },
  },
  filters: {
    formatDuration: function (value) {
      if (value.broadcast !== null) {
        const duration = value.broadcast.duration;
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60);
        var seconds = duration - hours * 3600 - minutes * 60;

        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }

        if (hours != "00") {
          return hours + ":" + minutes + ":" + seconds;
        } else {
          return minutes + ":" + seconds;
        }
      } else return "";
    },
    formatDate: formatDate,
  },
};
</script>

<style>
/* .item-name {
  color: #999 !important;
} */

img[lazy] {
  /* background: #222; */
}
.item-footer{
  position: absolute;
  width: -webkit-fill-available;
  padding: 0 10px;
  bottom: 10px;
  
  font-family: Roboto;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
}

.nextContentTitle{
  display: flex;
  justify-content: space-between;
}

.nextContentTitleLeft{
  display: flex;
  align-items: center;
  justify-items: flex-start;

}
.nextContentTitleLeft svg{
  margin-right: 5px;
}

.nav-btn{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.flex-between{
  display: flex;
  justify-content: space-between;
}

.flex-v-center{
  display: flex;
  align-items: center;
}
.flex-h-center{
  display: flex;
  justify-content: center;
}
.flex-h-start{
  display: flex;
  justify-content: flex-start;
}

@media only screen and (max-width: 992px) {
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  /* display: none; */
  opacity: 0.35;
}

.swiper-button-next,
.swiper-button-prev {
  position: relative;
  border: 2px solid #9747FF;
  /* background-color: #131318; */
  padding: 3px;
  box-sizing: border-box;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  top: 10px;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  /* color: #9747FF; */
  font-size: 13px;
}

.swiper-button-next:after {
  padding-left: 3px;
}

.swiper-button-prev:after {
  padding-right: 3px;
}
.swiper-button-prev{
  left:-20px !important;
}

.poster-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 146px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  text-align: center;
}

.poster-overlay img {
  height: 100%;
  width: 100%;
}

.icon-carousel{
  vertical-align: middle;
      height: 19px;

}

</style>